export const {
  createElement,
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
  StrictMode,
} = WPTB.modules.React;
